module.exports = __webpack_public_path__ + "static/media/PW.d56b9baf.png";